import { createApi } from "@reduxjs/toolkit/query/react";
import { DynamicBaseQuery } from "./baseQuery";
import { UrgentConcernsIndexResponse } from "./types/urgentConcerns/responses/UrgentConcernsIndexResponse";
import { UrgentConcernStatusEnum } from "./types/shiftHandover/enums/UrgentConcernStatusEnum";

interface GetResidentUrgentConcernsParams {
  residentId: number;
  page?: number;
  filter?: {
    status?: UrgentConcernStatusEnum;
  };
}

export const urgentConcernsApi = createApi({
  reducerPath: "urgentConcernsApi",
  baseQuery: DynamicBaseQuery,
  tagTypes: ["UrgentConcerns"],
  endpoints: (builder) => ({
    getResidentUrgentConcernsIndex: builder.query<
      UrgentConcernsIndexResponse,
      GetResidentUrgentConcernsParams
    >({
      query: ({ residentId, page, filter }) => ({
        url: `/residents/${residentId}/urgent-concerns`,
        method: "GET",
        params: { page, "filter[status]": filter?.status },
      }),
      providesTags: ["UrgentConcerns"],
    }),
  }),
});

export const { useGetResidentUrgentConcernsIndexQuery } = urgentConcernsApi;
